// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__1dUWE","labelPrefix":"current-filter-tag_labelPrefix__6mEdF"};